import { DS_COLOR_PALETTE } from "@/src/design_system/shared/types/colorPalette.generated";
import { DS_USER_SIZE } from "@/src/design_system/data_display/user/types/size";
import { DS_USER_STATUS } from "@/src/design_system/data_display/user/types/status";

export const DS_TAG_CLASSES = {
  Tag: "ds-tag",
  Text: "ds-tag__text",
  RemoveButton: "ds-tag__remove-button",

  // Palette classes
  Palette01: "ds-palette--01",
  Palette02: "ds-palette--02",
  Palette03: "ds-palette--03",
  Palette04: "ds-palette--04",
  Palette05: "ds-palette--05",
  Palette06: "ds-palette--06",
  Palette07: "ds-palette--07",
  Palette08: "ds-palette--08",
  Palette09: "ds-palette--09",
  Palette10: "ds-palette--10",
  Palette11: "ds-palette--11",
  Palette12: "ds-palette--12",
  Palette13: "ds-palette--13",
  Palette14: "ds-palette--14",
} as const;

/** The tag has a single height, so the avatar size is fixed to fit its line height. */
export const DS_TAG_AVATAR_SIZE = DS_USER_SIZE.ExtraSmall;
export const DS_TAG_AVATAR_STATUS = DS_USER_STATUS.None;

export const DS_TAG_COLOR_PALETTE_TO_CLASS_MAP = {
  [DS_COLOR_PALETTE.Color01]: DS_TAG_CLASSES.Palette01,
  [DS_COLOR_PALETTE.Color02]: DS_TAG_CLASSES.Palette02,
  [DS_COLOR_PALETTE.Color03]: DS_TAG_CLASSES.Palette03,
  [DS_COLOR_PALETTE.Color04]: DS_TAG_CLASSES.Palette04,
  [DS_COLOR_PALETTE.Color05]: DS_TAG_CLASSES.Palette05,
  [DS_COLOR_PALETTE.Color06]: DS_TAG_CLASSES.Palette06,
  [DS_COLOR_PALETTE.Color07]: DS_TAG_CLASSES.Palette07,
  [DS_COLOR_PALETTE.Color08]: DS_TAG_CLASSES.Palette08,
  [DS_COLOR_PALETTE.Color09]: DS_TAG_CLASSES.Palette09,
  [DS_COLOR_PALETTE.Color10]: DS_TAG_CLASSES.Palette10,
  [DS_COLOR_PALETTE.Color11]: DS_TAG_CLASSES.Palette11,
  [DS_COLOR_PALETTE.Color12]: DS_TAG_CLASSES.Palette12,
  [DS_COLOR_PALETTE.Color13]: DS_TAG_CLASSES.Palette13,
  [DS_COLOR_PALETTE.Color14]: DS_TAG_CLASSES.Palette14,
} as const;
